export default __webpack_public_path__ + "static/ready_to_hire_banner-abc0940cd8145781022a58f65b8bb5fc.png";